import type { JsonSchema } from '../types/schema';

export const downloadSchemaFile = (schema: JsonSchema) => {
  const data = JSON.stringify(schema, null, 2);
  const blob = new Blob([data], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = `schema-${schema['x-version'] ?? 'model'}.json`;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};

export const downloadTextFile = (filename: string, content: string, mimeType: string) => {
  const blob = new Blob([content], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
};
